import { Locale } from '../../constants/locales';
export const detectUserLanguage = ({ supportedLocales, fallbackLocale = Locale.en_US, }) => {
    return detectBrowserLocale(supportedLocales) || fallbackLocale;
};
const detectBrowserLocale = (supportedLocales) => {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        const intlLocale = new Intl.DateTimeFormat().resolvedOptions().locale;
        if (intlLocale) {
            const matchingLocale = findMatchingLocale(supportedLocales, intlLocale);
            if (matchingLocale) {
                return matchingLocale;
            }
        }
    }
    catch (error) {
        console.warn('Failed to detect locale using Intl.DateTimeFormat:', error);
    }
    const browserLanguages = navigator.languages || [navigator.language];
    for (const browserLang of browserLanguages) {
        if (!browserLang) {
            continue;
        }
        const matchingLocale = findMatchingLocale(supportedLocales, browserLang);
        if (matchingLocale) {
            return matchingLocale;
        }
    }
    return null;
};
const findMatchingLocale = (supportedLocales, targetLocale) => {
    const normalizedTarget = targetLocale.toLowerCase();
    const exactMatch = supportedLocales.find((locale) => locale.toLowerCase() === normalizedTarget);
    if (exactMatch) {
        return exactMatch;
    }
    const langCode = normalizedTarget.split('-')[0];
    const languageMatch = supportedLocales.find((locale) => locale.toLowerCase().startsWith(`${langCode}-`));
    if (languageMatch) {
        return languageMatch;
    }
    return null;
};
